import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UIState, Theme } from '../types';

// Helper to apply theme class to document root
const applyThemeClass = (theme: Theme) => {
  if (typeof document !== 'undefined') {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }
};

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      theme: 'light' as Theme,

      toggleSidebar: () =>
        set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),

      setTheme: (theme: Theme) => {
        // Apply theme class immediately when setting
        applyThemeClass(theme);
        set({ theme });
      },
    }),
    {
      name: 'ui-storage',
      onRehydrateStorage: () => (state) => {
        // Apply theme class when store rehydrates from localStorage
        if (state?.theme) {
          applyThemeClass(state.theme);
        }
      },
    }
  )
);
